<template>
  <div id="boton-capacitacion">
    <v-container grid-list-xl fluid>
      <v-flex lg12>
        <v-card>
          <boton-proceso-tab-capacitacion
            :lstBtn="lstBtn"
          ></boton-proceso-tab-capacitacion>
        </v-card>
        <div v-if="loading">
          <loading></loading>
        </div>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import Material from "vuetify/es5/util/colors";
import BotonProcesoTabCapacitacion from "@/modules/configuration/commonsviews/BotonProcesoTabCapacitacion.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "boton-capacitacion",

  components: {
    MiniStatistic,
    BotonProcesoTabCapacitacion,
    Loading,
  },
  data: () => ({
    color: Material,
    iconoBoton: "fa-print",
    tituloBoton: "Capacitacion",
    colorBoton: "yellow darken-4",
    lstBtn: [],
    lstBtnCompleta: [
      {
        icon: "fa-print",
        title: "Capacitación",
        subtitle: "",
        color: "yellow darken-3",
        class: "impresion rombo elevation-10",
        subPro: "RELATOR", //valor para subproceso en BotonProcesoTabCapacitacion.vue
        tab: "Relator", //valor para tab en BotonProcesoTabCapacitacion.vue
      },
      {
        icon: "all_inbox",
        title: "Seleccion",
        subtitle: "",
        color: "purple darken-2",
        class: "mecanizado rombo elevation-10",
        subPro: "SELECCION",
        tab: "Capacitacion",
      },
      {
        icon: "event_note",
        title: "Centros",
        subtitle: "",
        color: "teal",
        class: "distribucion rombo elevation-10",
        subPro: "CENTROS-CAP",
        tab: "Capacitacion",
      },
      {
        icon: "business",
        title: "Administrativo",
        subtitle: "",
        color: "blue darken-3",
        class: "administrativo rombo elevation-10",
        subPro: "ADMINISTRATIVO",
        tab: "Administrativo",
      },
      // dsoto 16-11-2022
      {
        icon: "all_inbox",
        title: "Prod&Report",
        subtitle: "",
        color: "yellow darken-3",
        class: "prod rombo elevation-10",
        subPro: "REPORTES",
        tab: "Productos",
      },
    ],
  }),
  computed: {},
  Mounted() {},
  created() {
    this.loadDataPanelControl();
  },
  methods: {
    async loadDataPanelControl() {
      this.loading = true;
      let lstBtnTmp = await this.loadPanelControl();
      for (let i = 0; i < lstBtnTmp.length; i++) {
        this.lstBtn.push(this.lstBtnCompleta[lstBtnTmp[i] - 1]);
      }
      this.loading = false;
    },
    async loadPanelControl() {
      return await axios
        .get(
          "/panelControl/posicionActivos/" + this.$store.getters.contratoStored
        )
        .then(function (response) {
          // console.log('response  orden mosrar capacitacion:' + response.data);
          return response.data;
        })
        .catch(function (error) {
          console.log("error loadPanelControl:" + error);
        });
    },
  },
};
</script>
